"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _reactMotion = require("react-motion");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _controls = _interopRequireDefault(require("./controls"));

var _arrow = _interopRequireDefault(require("./arrow"));

var _dots = _interopRequireDefault(require("./dots"));

var _excluded = ["slidesToShow", "slidesToChange", "teardown"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var calculateMaxPages = function calculateMaxPages(children, slidesToChange, slidesToShow) {
  if (slidesToShow === void 0) {
    slidesToShow = 1;
  }

  return slidesToChange ? Math.ceil((_react.Children.count(children) - slidesToShow) / slidesToChange) : Math.ceil((_react.Children.count(children) - slidesToShow) / slidesToShow);
};

var Slider = function Slider(_ref) {
  var defaultAllowOverflow = _ref.allowOverflow,
      children = _ref.children,
      className = _ref.className,
      defaultCustomControls = _ref.customControls,
      defaultCustomDots = _ref.customDots,
      defaultCustonDotsContainer = _ref.customDotsContainer,
      dotsOnClick = _ref.dotsOnClick,
      expand = _ref.expand,
      defaultHideArrows = _ref.hideArrows,
      defaultHideControls = _ref.hideControls,
      defaultHideDots = _ref.hideDots,
      defaultInitialPage = _ref.initialPage,
      nextArrow = _ref.nextArrow,
      nextOnClick = _ref.nextOnClick,
      onDecrementPage = _ref.onDecrementPage,
      onIncrementPage = _ref.onIncrementPage,
      onPageChange = _ref.onPageChange,
      onDrag = _ref.onDrag,
      onSwipe = _ref.onSwipe,
      defaultOverflowVisible = _ref.overflowVisible,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "relative" : _ref$position,
      prevArrow = _ref.prevArrow,
      prevOnClick = _ref.prevOnClick,
      responsive = _ref.responsive,
      siteViewportWidth = _ref.siteViewportWidth,
      defaultSlidesToChange = _ref.slidesToChange,
      defaultSlidesToShow = _ref.slidesToShow,
      defaultTeardown = _ref.teardown,
      defaultTouch = _ref.touch,
      wrapperProps = _ref.wrapperProps;
  var sliderRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(0),
      currentPage = _useState[0],
      setCurrenPage = _useState[1];

  var _useState2 = (0, _react.useState)(0),
      dragDistance = _useState2[0],
      setDragDistance = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      dragStart = _useState3[0],
      setDragStart = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      dragging = _useState4[0],
      setDraggging = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      hideControlsState = _useState5[0],
      setHideControlsState = _useState5[1];

  var _useState6 = (0, _react.useState)(false),
      teardown = _useState6[0],
      setTeardown = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      viewportWidth = _useState7[0],
      setViewportWidth = _useState7[1];

  var defaults = (0, _react.useMemo)(function () {
    return {
      allowOverflow: defaultAllowOverflow,
      customControls: defaultCustomControls,
      customDots: defaultCustomDots,
      customDotsContainer: defaultCustonDotsContainer,
      hideArrows: defaultHideArrows,
      hideControls: defaultHideControls,
      hideDots: defaultHideDots,
      initialPage: defaultInitialPage,
      overflowVisible: defaultOverflowVisible,
      slidesToChange: defaultSlidesToChange,
      slidesToShow: defaultSlidesToShow,
      teardown: defaultTeardown,
      touch: defaultTouch
    };
  }, [defaultAllowOverflow, defaultCustomControls, defaultCustomDots, defaultCustonDotsContainer, defaultHideArrows, defaultHideControls, defaultHideDots, defaultInitialPage, defaultOverflowVisible, defaultSlidesToChange, defaultSlidesToShow, defaultTeardown, defaultTouch]);

  var _useMemo = (0, _react.useMemo)(function () {
    return responsive // get breakpoints that are below viewportWidth (mobile first)
    .filter(function (obj) {
      return obj.breakpoint <= viewportWidth;
    }) // update max number of pages per object
    .map(function (_ref2) {
      var _ref2$slidesToShow = _ref2.slidesToShow,
          mapSlidesToShow = _ref2$slidesToShow === void 0 ? defaultSlidesToShow : _ref2$slidesToShow,
          _ref2$slidesToChange = _ref2.slidesToChange,
          mapSlidesToChange = _ref2$slidesToChange === void 0 ? defaultSlidesToChange : _ref2$slidesToChange,
          _ref2$teardown = _ref2.teardown,
          mapTeardown = _ref2$teardown === void 0 ? defaultTeardown : _ref2$teardown,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

      return Object.assign({}, rest, {
        maxPages: calculateMaxPages(children, mapSlidesToChange, mapSlidesToShow),
        slideWidth: mapSlidesToShow ? 1 / mapSlidesToShow : 1,
        slidesToChange: mapSlidesToChange,
        slidesToShow: mapSlidesToShow,
        teardown: mapTeardown
      });
    }).reduce(function (accum, obj) {
      if (obj.breakpoint >= accum.breakpoint) {
        setTeardown(obj.teardown);
        return Object.assign({}, defaults, obj);
      }

      return accum;
    }, Object.assign({
      breakpoint: 0
    }, defaults));
  }, [children, defaultSlidesToChange, defaultSlidesToShow, defaultTeardown, defaults, responsive, viewportWidth]),
      allowOverflow = _useMemo.allowOverflow,
      customControls = _useMemo.customControls,
      customDots = _useMemo.customDots,
      customDotsContainer = _useMemo.customDotsContainer,
      hideArrows = _useMemo.hideArrows,
      hideControls = _useMemo.hideControls,
      hideDots = _useMemo.hideDots,
      initialPage = _useMemo.initialPage,
      maxPages = _useMemo.maxPages,
      overflowVisible = _useMemo.overflowVisible,
      slidesToShow = _useMemo.slidesToShow,
      slidesToChange = _useMemo.slidesToChange,
      slideWidth = _useMemo.slideWidth,
      touch = _useMemo.touch; // handle all updating of currentPage


  var updateCurrentPage = (0, _react.useCallback)(function (page) {
    (0, _utils.callIfFunc)(onPageChange, page);
    setCurrenPage(page);
    setDraggging(false);
  }, [onPageChange]);
  var incrementPage = (0, _react.useCallback)(function () {
    (0, _utils.callIfFunc)(onIncrementPage);
    updateCurrentPage(currentPage + 1);
  }, [currentPage, onIncrementPage, updateCurrentPage]);
  var decrementPage = (0, _react.useCallback)(function () {
    (0, _utils.callIfFunc)(onDecrementPage);
    updateCurrentPage(currentPage - 1);
  }, [currentPage, onDecrementPage, updateCurrentPage]); // handle updating of viewport width

  var updateViewportState = (0, _react.useCallback)(function () {
    setViewportWidth(window.innerWidth);
  }, []);
  var handleMouseMove = (0, _react.useCallback)(function (_ref3) {
    var clientX = _ref3.clientX;
    var drag = sliderRef.current && sliderRef.current.clientWidth ? Math.round((dragStart - clientX) / sliderRef.current.clientWidth * 100) : Math.round((dragStart - clientX) / viewportWidth * 100);
    var threshold = slideWidth * slidesToShow * 30;

    if (dragging) {
      if (Math.abs(drag) > threshold) {
        (0, _utils.callIfFunc)(onSwipe);

        if (drag > 0) {
          incrementPage();
        } else if (drag < 0) {
          decrementPage();
        }
      } else if (Math.abs(drag) < threshold) {
        (0, _utils.callIfFunc)(onDrag);
        setDragDistance(drag);
      }
    }
  }, [decrementPage, dragStart, dragging, incrementPage, onDrag, onSwipe, slideWidth, slidesToShow, viewportWidth]);
  var handleMouseDown = (0, _react.useCallback)(function (_ref4) {
    var clientX = _ref4.clientX;
    setDragStart(clientX);
    setDraggging(true);
  }, []); // handle drag events

  var handleTouchMove = (0, _react.useCallback)(function (e) {
    handleMouseMove(e.touches[0]);
  }, [handleMouseMove]);
  var handleTouchStart = (0, _react.useCallback)(function (e) {
    handleMouseDown(e.touches[0]);
  }, [handleMouseDown]);
  var resetDragParams = (0, _react.useCallback)(function () {
    setDragDistance(0);
    setDragStart(0);
    setDraggging(false);
  }, []);
  var isTouch = (0, _react.useMemo)(function () {
    return !teardown && touch;
  }, [teardown, touch]);
  (0, _react.useEffect)(function () {
    setCurrenPage(initialPage);
  }, [initialPage]);
  (0, _react.useEffect)(function () {
    updateViewportState();

    if (!siteViewportWidth) {
      window.addEventListener("resize", updateViewportState);
    }

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchmove", handleTouchMove);
    return function () {
      if (!siteViewportWidth) {
        window.removeEventListener("resize", updateViewportState);
      }

      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [updateViewportState, handleMouseMove, handleTouchMove, siteViewportWidth]);
  var overflow = (0, _react.useMemo)(function () {
    if (overflowVisible) {
      return "visible";
    }

    if (teardown) {
      return "scroll";
    }

    return "hidden";
  }, [overflowVisible, teardown]); // handle all updating of translateX

  var transValue = (0, _react.useMemo)(function () {
    // translation calculations
    var numberOfSlides = _react.Children.count(children);

    var transValueWithoutOverflow = (numberOfSlides - slidesToShow) * slideWidth * 100;
    var transValueWithOverflow = (maxPages + slidesToChange / slidesToShow) * 100;
    var pageTranslateWidth = slidesToChange * slideWidth * 100;
    var maxTrans = Math.max(0, allowOverflow ? transValueWithOverflow : transValueWithoutOverflow);
    var maxTransWithDrag = maxTrans + 5;
    var minTrans = -5;
    var newTransValue = (0, _ramda.clamp)(minTrans, maxTrans, currentPage * pageTranslateWidth);
    setHideControlsState(numberOfSlides <= slidesToShow);
    return (0, _ramda.clamp)(minTrans, maxTransWithDrag, newTransValue + dragDistance);
  }, [allowOverflow, children, currentPage, dragDistance, maxPages, slideWidth, slidesToChange, slidesToShow]);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    className: className,
    maxWidth: "100%",
    overflow: overflow,
    position: position,
    ref: sliderRef.current,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_reactMotion.Motion, {
    defaultStyle: {
      drag: 0,
      transform: 0
    },
    style: {
      transform: (0, _reactMotion.spring)(-transValue, {
        dampening: 0,
        stiffness: 180
      })
    }
  }, function (style) {
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
      onMouseDown: isTouch ? handleMouseDown : null,
      onMouseLeave: resetDragParams,
      onMouseUp: isTouch ? resetDragParams : null,
      onTouchEnd: isTouch ? resetDragParams : null,
      onTouchStart: isTouch ? handleTouchStart : null,
      style: {
        transform: "translate3d(" + style.transform + "%, 0, 0)"
      }
    }, wrapperProps), _react.Children.map(children, function (child) {
      return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
        key: child.key,
        display: "inline-block",
        flex: (expand ? 1 : 0) + " 0 auto",
        width: slideWidth || "auto"
      }, child);
    }));
  }), teardown || hideControlsState || hideControls ? null : /*#__PURE__*/_react["default"].createElement(_controls["default"], {
    customControls: customControls
  }, hideArrows ? null : /*#__PURE__*/_react["default"].createElement(_arrow["default"], {
    customArrow: prevArrow,
    direction: "left",
    disabled: currentPage === 0,
    onClick: function onClick() {
      decrementPage();
      (0, _utils.callIfFunc)(prevOnClick);
    }
  }), hideDots ? null : /*#__PURE__*/_react["default"].createElement(_dots["default"], {
    currentPage: currentPage,
    customDots: customDots,
    customDotsContainer: customDotsContainer,
    length: maxPages + 1,
    onDotClick: function onDotClick(pageNumber) {
      updateCurrentPage(pageNumber);
      (0, _utils.callIfFunc)(dotsOnClick, pageNumber);
    }
  }), hideArrows ? null : /*#__PURE__*/_react["default"].createElement(_arrow["default"], {
    customArrow: nextArrow,
    direction: "right",
    disabled: maxPages === currentPage,
    onClick: function onClick() {
      incrementPage();
      (0, _utils.callIfFunc)(nextOnClick);
    }
  })));
};

Slider.propTypes = {
  allowOverflow: _propTypes.bool,
  children: _propTypes.node || _propTypes.func,
  className: _propTypes.string,

  /** Custom controls container, needs to render children */
  customControls: _propTypes.func,

  /** Custom dots container */
  customDots: _propTypes.func,

  /** Custom dots, needs to bind onClick prop */
  customDotsContainer: _propTypes.func,

  /** Custom onclick function for dots */
  dotsOnClick: _propTypes.func,
  expand: _propTypes.bool,

  /** Hide arrows setting */
  hideArrows: _propTypes.bool,

  /** Hide controls setting */
  hideControls: _propTypes.bool,

  /** Hide dots setting */
  hideDots: _propTypes.bool,

  /** Initial starting page */
  initialPage: _propTypes.number,

  /** Custom next button, needs to bind onClick prop */
  nextArrow: _propTypes.func,

  /** Custom onclick function for next arrow */
  nextOnClick: _propTypes.func,

  /** Function that triggers on page decrement */
  onDecrementPage: _propTypes.func,

  /** Function that triggers on drag */
  onDrag: _propTypes.func,

  /** Function that triggers on page increment */
  onIncrementPage: _propTypes.func,

  /** Function that triggers on page change */
  onPageChange: _propTypes.func,

  /** Function that triggers on swipe */
  onSwipe: _propTypes.func,

  /** Show all slides */
  overflowVisible: _propTypes.bool,

  /** postion prop of main container */
  position: _propTypes.string,

  /** Custom prep button , needs to bind onClick prop */
  prevArrow: _propTypes.func,

  /** Custom onclick function for prev arrow */
  prevOnClick: _propTypes.func,

  /** Array of objects overriding props by breakpoint key */
  responsive: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    breakpoint: _propTypes.number,
    settings: (0, _propTypes.shape)({
      slidesToScroll: _propTypes.number,
      slidesToShow: _propTypes.number
    })
  })),

  /** number given with the viewport width */
  siteViewportWidth: _propTypes.number,

  /** Number of slides to change per scroll */
  slidesToChange: _propTypes.number,

  /** Number of slides shown per page */
  slidesToShow: _propTypes.number,

  /** Teardown the slider and just use overflow */
  teardown: _propTypes.bool,

  /** Enable touch setting */
  touch: _propTypes.bool,
  wrapperProps: (0, _propTypes.shape)({
    m: _utils.stylePropType
  })
};
Slider.defaultProps = {
  allowOverflow: false,
  expand: false,
  hideArrows: false,
  hideControls: false,
  hideDots: false,
  initialPage: 0,
  overflowVisible: false,
  responsive: [{
    breakpoint: 0
  }],
  slidesToChange: 1,
  slidesToShow: 1,
  teardown: false,
  touch: true
};
var _default = Slider;
exports["default"] = _default;